import { InputText } from "primereact/inputtext";
import { classNames } from "primereact/utils";
import { useTranslation } from "react-i18next";
import { Controller, useForm} from 'react-hook-form';
import { Button } from "primereact/button";
import { Editor } from "primereact/editor";

export default function NotificacaoCadastrar({notificacao, onClose, onSave, msgs}:{notificacao:any, onClose: () => void, onSave: (notificacao:any) => void, msgs:any}) {
  const { t } = useTranslation();
  const defaultValues = {
    titulo: '',
    conteudo:''
  };
  defaultValues.titulo = notificacao.titulo ? notificacao.titulo.toString() : ''
  defaultValues.conteudo = notificacao.conteudo ? notificacao.conteudo.toString() : ''
  
  
  const {
      control,
      formState: { errors},
      handleSubmit
  } = useForm({ defaultValues });

  const onSubmit = (data:any) => {
      data.titulo && save(data);
  };

 
  const save = (data:any) => {
    const franq = {
      id: notificacao.id? notificacao.id : undefined,
      titulo:data.titulo,
      conteudo:data.conteudo
    }
    window.scrollTo(0, 0);
    onSave(franq);
  }
  
  const getFormErrorMessage = (name:string) => {
    type ObjectKey = keyof typeof errors;
    const error = errors[Object.keys(errors).find(k => k === name) as ObjectKey]
    return error ? <small className="p-error">{error.message}</small> : <small className="p-error">&nbsp;</small>;
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="flex flex-column gap-2">
        <div>
          <div className="grid">
              <div className="col p-fluid flex flex-wrap">
                
                  <Controller
                      name="titulo"
                      control={control}
                      rules={{ required: 'Título é Obrigatório' }}
                      render={({ field, fieldState }) => (
                          <>
                              <label htmlFor={field.name} className={classNames({ 'p-error': errors.titulo })}></label>
                              <span className="">
                              <div>
                                <label htmlFor="titulo" className="font-bold block mb-2 required">{t('titulo')} </label>
                                <InputText style={{width:'100%'}} id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                                </div>
                              </span>
                              {getFormErrorMessage(field.name)}
                          </>
                      )}
                  />
                    
               
              </div>
          </div>
          <div className="grid">
            
            <div className="col">
                <Controller
                      name="conteudo"
                      control={control}
                      
                      render={({ field, fieldState }) => (
                          <>
                              <label htmlFor={field.name} className={classNames({ 'p-error': errors.conteudo })}></label>
                              <span className="">
                              <div>
                                  <label htmlFor="conteudo" className="font-bold block mb-2">{t('conteudo')} </label>
                                  <Editor id={field.name} value={field.value} onTextChange={(e) => field.onChange(e.htmlValue)} style={{ height: '320px' }} />
                              </div>
                              </span>
                              {getFormErrorMessage(field.name)}
                          </>
                      )}
                  />
               
              </div>
          </div>
          
        </div>
        <br></br>
        <br></br>
        <div style={{display:"flex", justifyContent:"flex-end", paddingTop:"1rem"}} className=" flex">
            <Button style={{marginRight:"1rem", backgroundColor:'#183462'}} label="Salvar" type="submit"   />
            <Button icon="pi pi-times" onClick={onClose} rounded outlined severity="danger" aria-label="Cancel" />
        </div> 
    </form>
    
  )
}

